import {$http} from '@utils'
import queryString from 'query-string'
import api from '@utils/api'
const formatData = function(payload){
    if(!payload.data){
        payload = {
            ...payload,
            data:[],
            count:0
        }
    } else if(payload.data.length>0&&!payload.data[0]) {
        payload = {
            ...payload,
            data:[],
            count:0
        }
    }
    return payload
}
export default {
    namespaced: true,
    state:{
        empList:[],
        empListCount:0,
        rolesList:[],
    },
    mutations:{
        getEmpList(state,payload){
            payload = formatData(payload)
            state.empList = payload.data
            state.empListCount = payload.count
        },
        listAllRoles(state,payload){
            payload = formatData(payload)
            state.rolesList = payload.data
            // state.rolesList = [
            //     {id:'0',roleType:'0',roleName:'标准',desc:'只是一段描述'},
            //     {id:'1',roleType:'1',roleName:'客服',desc:'只是一段描述只是一段描述'}
            //     ]
        }
    },
    actions:{
        async getEmpList ({commit},{params}) {
            const res = await $http.post(`${api.mainHost}${api.mainContentPath}/account/empList.do`,queryString.stringify({param:params}),{
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (res.code * 1 === 1) {
                commit('getEmpList', res)
            } else {
                console.log(res.msg)
            }
        },
        async listAllRoles ({commit},{params}) {
            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/role/listAllRoles.do?${queryString.stringify(params)}`);
            if (res.code * 1 === 1) {
                commit('listAllRoles', res)
            } else {
                console.log(res.msg)
            }

        },
        // 状态更新
        async changeEmpStatus ({commit},{param,callback}) {
            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/account/changeEmpStatus.do?${queryString.stringify(param)}`);
          return res
           // debugger
           //  if (res.code * 1 === 1) {
           //      callback&&callback()
           //  } else {}
        },
         // 员工解绑租户
         async unBindTenantStatus ({commit},{param,callback}) {
            const res = await $http.get(`${api.mainHost}${api.mainContentPath}/account/delAccountAndSsoUserByUserId.do?${queryString.stringify(param)}`);
          return res
        },
    }
}